export enum ProjectLostStageReason {
  CLIENT_INACCESSIBLE = 'client-inaccessible',
  HIGH_PRICE = 'high-price',
  TERM = 'term',
  NOT_INTERESTED = 'not-interested',
  OTHER = 'other'
}
